import { render } from "./ListAccounts.vue?vue&type=template&id=1bd90c5a&scoped=true&ts=true"
import script from "./ListAccounts.vue?vue&type=script&lang=ts"
export * from "./ListAccounts.vue?vue&type=script&lang=ts"

import "./ListAccounts.vue?vue&type=style&index=0&id=1bd90c5a&scoped=true&lang=scss"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd90c5a"]])

export default __exports__